import { render, staticRenderFns } from "./CustomersChart.vue?vue&type=template&id=6443708b"
import script from "./CustomersChart.vue?vue&type=script&lang=js"
export * from "./CustomersChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports